'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toJS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * HOC that parse the immutable params to literals to wrapped component
 * @param {React.Component} - component to wrap
 * @returns {React.Component} - WrapComponent
* */
var toJS = exports.toJS = function toJS(WrappedComponent) {
  return function (wrappedComponentProps) {
    var propsJS = (0, _keys2.default)(wrappedComponentProps).reduce(function (newProps, wrappedComponentProp) {
      return (0, _assign2.default)({}, newProps, (0, _defineProperty3.default)({}, wrappedComponentProp, _immutable.Iterable.isIterable(wrappedComponentProps[wrappedComponentProp]) ? wrappedComponentProps[wrappedComponentProp].toJS() : wrappedComponentProps[wrappedComponentProp]));
    }, {});

    return _react2.default.createElement(WrappedComponent, propsJS);
  };
};

exports.default = toJS;